export default "__VITE_ASSET__ByTcBTOU__"